import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const anon = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anon && !url.includes('placeholder'));

let supabaseInstance: ReturnType<typeof createClient>;

try {
  if (!isSupabaseConfigured) {
    console.warn('Missing Supabase credentials. App will run in offline mock mode.');
    supabaseInstance = createClient('https://placeholder.supabase.co', 'placeholder-key', {
      auth: { persistSession: false, autoRefreshToken: false },
    });
  } else {
    supabaseInstance = createClient(url, anon, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
      global: {
        headers: { apikey: anon },
      },
    });
  }
} catch (err) {
  console.error('Failed to initialize Supabase client:', err);
  supabaseInstance = createClient('https://placeholder.supabase.co', 'placeholder-key', {
    auth: { persistSession: false, autoRefreshToken: false },
  });
}

export const supabase = supabaseInstance;

export function supabaseWithQuoteToken(token: string) {
  if (!isSupabaseConfigured) throw new Error('Supabase not configured');
  return createClient(url, anon, {
    auth: { persistSession: false },
    global: { headers: { 'x-quote-token': token } },
  });
}

export function supabaseWithDeliveryToken(token: string) {
  if (!isSupabaseConfigured) throw new Error('Supabase not configured');
  return createClient(url, anon, {
    auth: { persistSession: false },
    global: { headers: { 'x-delivery-token': token } },
  });
}